import api from 'api'

type CreateBillRateRequest = {
  companyId: number
  positionId: number
  payRate: number
  billRate: number
}

export const createBillRate = async (
  request: CreateBillRateRequest
): Promise<void> => {
  await api.post('/admin/bill_rate', {
    companyId: request.companyId,
    positionId: request.positionId,
    payRate: request.payRate,
    billRate: request.billRate,
  })
}
